import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosInstance";
import axios from "axios";

interface authState {
  authResponse: {};
}

const initialState: authState = {
  authResponse: {},
};

const authSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchToken.fulfilled, (state, action) => {
        state.authResponse = action.payload;
      })
      .addCase(fetchToken.pending, (state, action) => {})
      .addCase(fetchToken.rejected, (state, action) => {});
  },
});

export default authSlice.reducer;

export const fetchToken = createAsyncThunk("/fetchToken", async (code: any) => {
  const response = await axiosInstance.get(`token/fetchToken?authCode=${code}`);
  return response.data;
});

export const refreshToken = createAsyncThunk(
  "/refreshToken",
  async (code: any) => {
    const response = await axiosInstance.get(`token/refreshToken`);
    return response.data;
  }
);

export const logout = createAsyncThunk("/logout", async () => {
  let refreshToken = localStorage.getItem("refresh_token");

  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}/token/logout`,
    {
      headers: {
        Authorization: `Bearer ${refreshToken}`,
      },
    }
  );
  return response.data;
});
